function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.dimensions,
    height: $props.dimensions,
    style: _normalizeStyle({
      width: $props.dimensions + 'px',
      height: $props.dimensions + 'px'
    }),
    class: "doris-icon",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("path", {
    d: "M12.4756 35.115L24.0001 23.5905L35.5246 12.066L12.4756 35.115Z",
    "stroke-width": "1.4",
    "stroke-linejoin": "round"
  }, null, -1 /* CACHED */), _createElementVNode("circle", {
    cx: "14",
    cy: "14",
    r: "5",
    transform: "rotate(-180 14 14)",
    "stroke-width": "1.4",
    "stroke-linejoin": "round"
  }, null, -1 /* CACHED */), _createElementVNode("circle", {
    cx: "34",
    cy: "34",
    r: "5",
    transform: "rotate(-180 34 34)",
    "stroke-width": "1.4",
    "stroke-linejoin": "round"
  }, null, -1 /* CACHED */)])), 12 /* STYLE, PROPS */, _hoisted_1);
}